import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";

import Grid from '@material-ui/core/Grid';
import { Link } from 'gatsby';

import Container from '../Container';
import { componentLayoutProps } from '../../types';

const ComponentLayout = ({ heading, description, sectionData }: componentLayoutProps) => {
  const data = useStaticQuery(graphql`
    query {
      macImage: file(relativePath: {eq: "mac-icon.png"}) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      windowsImage: file(relativePath: {eq: "windows-icon.png"}) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      linuxImage: file(relativePath: {eq: "linux-icon.png"}) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      free: file(relativePath: {eq: "Free.png"}) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      quality: file(relativePath: {eq: "Quality.png"}) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      customise: file(relativePath: {eq: "Customise.png"}) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)
  return (
    <div className="component-layout" id={sectionData.mainHeading}>
      <Container>
        <h2 className="global-heading large-font">{heading}</h2>
        <h3 className="description small-font">
          {description}
        </h3>
        <Grid container className="grid-container">
          {sectionData.grid.map((card) => {
            return (
              <Grid item sm={4} xs={12}>
                <div className="grid-card">
                  {card.image && <div className="image-wrapper">
                    <Img fluid={data[card.image].childImageSharp.fluid} alt={card.headingBlack? card.headingBlack: card.headingRed}/>
                  </div>}
                  <h2 className="heading-black mediuam-font">
                    <Link to={card.link} target="blank">{card.headingBlack}</Link>
                  </h2>
                  <h2 className="heading-red mediuam-font">
                    {card.headingRed}
                  </h2>
                  <h3 className="card-description small-font">
                    {card.description}
                  </h3>
                </div>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </div>
  );
};

ComponentLayout.propTypes = {
  sectionData: PropTypes.any.isRequired,
};

export default ComponentLayout;
